/**************************************************************
 * getCustomerId()
 * -> Retorna o ID do cliente via window.ShopifyAnalytics.meta.page.customerId
 **************************************************************/
function getCustomerId() {
  try {
    if (
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page
    ) {
      var id = window.ShopifyAnalytics.meta.page.customerId;
      return id || null;
    }
    return null;
  } catch (error) {
    console.error("[getCustomerId] Erro:", error);
    return null;
  }
}

/**************************************************************
 * getB2BCustomer(customerId)
 * -> Faz uma query GraphQL para obter dados B2B do cliente
 **************************************************************/

function getB2BCustomer(customerId) {
  try {
    return fetch(
      `${baseUrl}/shopify-order-connector/v1/shopify-order-connector/b2b-informations?customerId=${customerId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        return result || null;
      });
  } catch (error) {
    console.error(error);
  }
}

/**************************************************************
 * setDataLayer()
 * -> Monta o dataLayerObj e inclui novos campos dos Metafields
 **************************************************************/
function setDataLayer() {
  var customerId = getCustomerId();
  if (!customerId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      FK_TIMESTAMP: new Date().toISOString(),
      FK_PAGEURL: window.location.href,
    });
    return;
  }

  const cnpjC = getCnpjC();

  if (cnpjC) {
    getB2BCustomer(customerId).then(function (response) {
      if (!response) {
        console.error("[setDataLayer] Erro ao carregar dados B2B do cliente.");
        return;
      }

      var address = response.defaultAddress || {};
      window.dataLayer = window.dataLayer || [];

      var dataLayerObj = {
        FK_UID: customerId,
        FK_U_NAME: response.customer.firstName || "not set",
        FK_U_SURNAME: response.customer.lastName || "not set",
        FK_U_EM: response.customer.email || "not set",
        FK_TIMESTAMP: new Date().toISOString(),
        FK_PAGEURL: window.location.href,
        FK_UTYPE: "Logado",
      };

      if (response.customer.companyContactProfiles?.length > 0) {
        var profile = response.customer.companyContactProfiles[0];
        var telesales = response.customer.metafield;
        var company = profile.company;
        if (company) {
          var companyMetafields = {};
            company.metafields?.nodes?.forEach((node) => {
            companyMetafields[node.key] = node.value;
          });

          var isTelesales = {};
          if (telesales) {
            isTelesales[telesales.key] = telesales.value;
          }

          dataLayerObj = {
            ...dataLayerObj,
            FK_ORG: company.name || "not set",
            FK_U_OD: companyMetafields["organizationDocument"] || "not set",
            FK_LineBusiness:
              companyMetafields["displayActivityBranch"] || "not set",
            FK_Status: companyMetafields["status"] || "not set",
            FK_PriceList: companyMetafields["priceList"] || "not set",
            FK_SalePriceList: companyMetafields["salePriceList"] || "not set",
            FK_CustomerErpId: companyMetafields["customerErpId"] || "not set",
            FK_OperationTypeCode:
              companyMetafields["operationTypeCode"] || "not set",
            FK_BaseTableCodeFkwBR:
              companyMetafields["baseTableCodeFkwBR"] || "not set",
            FK_BaseTableCodeFkwAR:
              companyMetafields["baseTableCodeFkwAR"] || "not set",
            FK_BaseTableCodeSohoBR:
              companyMetafields["baseTableCodeSohoBR"] || "not set",
            FK_SalesforceUpdateSuccess:
              companyMetafields["salesforceUpdateSuccess"] || "not set",
            FK_Cnae: companyMetafields["cnae"] || "not set",
            FK_TradeName: companyMetafields["tradeName"] || "not set",
            FK_StateTaxNumber: companyMetafields["stateTaxNumber"] || "not set",
            FK_Suframa: companyMetafields["suframa"] || "not set",
            FK_ProfileClass: companyMetafields["profileClass"] || "not set",
            FK_CompanyActive: companyMetafields["companyActive"] === "true",
            FK_ApprovalDate: companyMetafields["approvalDate"] || "not set",
            FK_CreationDate: companyMetafields["creationDate"] || "not set",
            FK_ContactName: companyMetafields["contactName"] || "not set",
            FK_ContactEmail: companyMetafields["contactEmail"] || "not set",
            FK_AcceptContactEmail:
              companyMetafields["acceptContactEmail"] === "true",
            FK_PhoneNumber: companyMetafields["phoneNumber"] || "not set",
            FK_IsTelesales:  isTelesales["istelesales"] || isTelesales["isTeleSales"] || "false",
          };
        }
      }

      window.dataLayer.push(dataLayerObj);
    });
  }
}

setDataLayer();
